import React from 'react';

const BENEFITS = [
  {
    title: 'Implementación ágil',
    description:
      'De la idea al despliegue sin ciclos eternos: diseñamos, desarrollamos y ponemos en producción tu solución en tiempo récord.',
    dot: '#000000',
  },
  {
    title: 'Soporte técnico real',
    description:
      'Acompañamiento humano detrás de cada implementación, no tickets perdidos ni respuestas automáticas.',
    dot: '#7C3AED',
  },
  {
    title: 'Se adapta a tu stack',
    description:
      'Trabajamos con el lenguaje, framework y nube que ya usas, sin obligarte a migrar nada.',
    dot: '#A78BFA',
  },
  {
    title: 'Resultados medibles',
    description:
      'Cada proceso automatizado o agente desplegado se traduce en tiempo y costos que puedes cuantificar.',
    dot: '#C7D2FE',
  },
];

// Recibe el trazo violeta que baja desde Stack por el borde izquierdo y, al
// entrar a un fondo blanco, vuelve al índigo claro del resto de circuitos.
// Baja recto todo el borde izquierdo y cruza al fondo (left: 38%) para
// entregarle el trazo al Footer en ese mismo punto.
const BenefitsCircuit = () => (
  <div className="absolute inset-0 z-0 pointer-events-none overflow-hidden" aria-hidden="true">
    <div className="absolute left-4 top-0 bottom-0 w-[1.5px] bg-[#C7D2FE] opacity-70" />
    <div className="absolute left-4 bottom-0 w-[calc(38%-16px)] h-[1.5px] bg-[#C7D2FE] opacity-70" />
    <div className="absolute left-[10px] bottom-0 w-[11px] h-[11px] rounded-full bg-[#A5B4FC] opacity-90" />
  </div>
);

// El conector sale del propio punto del título -- así queda garantizado que
// la línea está a la altura del título y no del párrafo, sin importar cuánto
// mida la descripción de cada beneficio.
const BenefitBlock = ({ benefit, className, flip }) => (
  <div className={className}>
    <div className={`flex items-center gap-2.5 mb-2.5 ${flip ? 'md:flex-row-reverse' : ''}`}>
      <span className="relative w-2 h-2 rounded-full shrink-0" style={{ backgroundColor: benefit.dot }} aria-hidden="true">
        <span
          className="hidden md:block absolute top-1/2 -translate-y-1/2 h-[1.5px] w-12 lg:w-16 bg-[#A78BFA] opacity-60"
          style={{ [flip ? 'left' : 'right']: '100%' }}
        />
      </span>
      <h3 className="text-black text-[16px] sm:text-[17px] font-semibold" style={{ letterSpacing: '-0.005em' }}>
        {benefit.title}
      </h3>
    </div>
    <p className={`text-black/60 text-[14px] sm:text-[15px] leading-relaxed ${flip ? 'md:text-right' : ''}`}>
      {benefit.description}
    </p>
  </div>
);

const MainframeBenefitsSection = () => {
  return (
    <section className="relative z-[1] bg-white px-5 sm:px-8 md:px-10 py-20 sm:py-28 overflow-hidden">
      <BenefitsCircuit />
      <div className="relative z-10 max-w-4xl mx-auto">
        <h2
          style={{ fontSize: 'clamp(26px, 4.2vw, 44px)', lineHeight: 1.15, fontWeight: 500, letterSpacing: '-0.01em' }}
          className="text-black text-center mb-14 sm:mb-16"
        >
          Beneficios de trabajar con Orbiax
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-[1fr_auto_1fr] gap-y-10 md:gap-x-12 lg:gap-x-16 md:items-center">
          <BenefitBlock benefit={BENEFITS[0]} flip className="order-2 md:order-none md:col-start-1 md:row-start-1" />

          <div className="group order-1 md:order-none md:col-start-2 md:row-start-1 md:row-span-2 relative mx-auto w-full max-w-[260px] sm:max-w-xs">
            {/* resplandor violeta sutil, retoma el color de las gafas de la mascota -- se realza al pasar el mouse */}
            <div
              className="absolute -inset-4 rounded-[1.75rem] blur-xl pointer-events-none transition-opacity duration-300 opacity-100 group-hover:opacity-0"
              style={{ background: 'radial-gradient(circle at 35% 25%, rgba(124,58,237,0.22), transparent 72%)' }}
              aria-hidden="true"
            />
            <div
              className="absolute -inset-4 rounded-[1.75rem] blur-xl pointer-events-none transition-opacity duration-300 opacity-0 group-hover:opacity-100"
              style={{ background: 'radial-gradient(circle at 35% 25%, rgba(124,58,237,0.4), transparent 72%)' }}
              aria-hidden="true"
            />
            <div
              className="relative rounded-2xl overflow-hidden shadow-[0_20px_45px_rgba(0,0,0,0.12)] border-2 border-transparent transition-all duration-300 group-hover:border-[#7C3AED] group-hover:shadow-[0_0_30px_rgba(124,58,237,0.4)]"
              style={{ aspectRatio: '3 / 4', backgroundColor: '#837e82' }}
            >
              <img
                src="/assets/mascota-poses/beneficios.webp"
                alt=""
                aria-hidden="true"
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
              />
            </div>
          </div>

          <BenefitBlock benefit={BENEFITS[1]} className="order-3 md:order-none md:col-start-3 md:row-start-1" />
          <BenefitBlock benefit={BENEFITS[2]} flip className="order-4 md:order-none md:col-start-1 md:row-start-2" />
          <BenefitBlock benefit={BENEFITS[3]} className="order-5 md:order-none md:col-start-3 md:row-start-2" />
        </div>
      </div>
    </section>
  );
};

export default MainframeBenefitsSection;
